import { render, staticRenderFns } from "./FieldWorkplace2List.vue?vue&type=template&id=660a182e&scoped=true&"
import script from "./FieldWorkplace2List.vue?vue&type=script&lang=js&"
export * from "./FieldWorkplace2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660a182e",
  null
  
)

export default component.exports